import { Alert, Box, Typography, styled } from "@mui/material";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { useNavigate } from "react-router-dom";

const StyledArrowForwardIosRoundedIcon = styled(ArrowForwardIosRoundedIcon)(
  ({ theme }) => ({
    color: theme.palette.icon.primary,
  }),
);

const StyledAlert = styled(Alert)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  position: "sticky",
  alignSelf: "center",
  width: "100%",
  margin: "16px 0px",
  backgroundColor: theme.palette.info.light,
  "&:hover": {
    backgroundColor: theme.palette.info.hover,
    cursor: "pointer",
  },
  "& .MuiAlert-message": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "4px",
  },
  "& .MuiAlert-icon": {
    color: theme.palette.info.main,
  },
}));

const InfoContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.info.dark,
}));

const InfoText = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  color: theme.palette.info.dark,
}));

export const PendingFeaAuthAlert: React.FC = () => {
  const navigate = useNavigate();
  return (
    <StyledAlert
      severity="info"
      onClick={() =>
        navigate(
          "/app/registro/firma-electronica-avanzada/validation-challenge",
        )
      }
      action={<StyledArrowForwardIosRoundedIcon />}
    >
      <InfoContainer>
        <Title>Firma electrónica pendiente</Title>
        <InfoText>
          Este proceso se hace solo una vez para poder emitir recetas
        </InfoText>
      </InfoContainer>
    </StyledAlert>
  );
};
